import { useState } from 'react'
import useDataLogin from './useDataLogin'
import { TbAlertCircle as AlertIcon } from 'react-icons/tb'
import { BiShow, BiHide } from 'react-icons/bi'
import Button from '../../components/ui/Button'

const Login = ({ handlePasswordDisplay }: any) => {
	const { loading, values, errors, touched, handleChange, handleSubmit, handleBlur } =
		useDataLogin()
	const [show, setShow] = useState(false)

	return (
		<div>
			<p className="text-dark mb-6 text-3xl font-semibold">Sign in</p>

			<form onSubmit={handleSubmit}>
				<div className="form-group mb-4 w-full">
					<label>Enter email</label>
					<input
						type="email"
						name="email"
						className="form-control"
						placeholder="Email"
						onChange={handleChange}
						onBlur={handleBlur}
						value={values.email}
					/>
					<div className="mt-2 flex items-center text-sm text-red-600" role="alert">
						{errors.email && touched.email && (
							<AlertIcon className="flex-shrink-1 me-1 inline h-4 w-4" />
						)}
						{errors.email && touched.email && (
							<div className="text-sm text-red-600" role="alert">
								<span className="font-medium">{errors.email}</span>
							</div>
						)}
					</div>
				</div>

				<div className="form-group mb-4">
					<label>Password</label>
					<div className="relative" style={{ position: 'relative' }}>
						<input
							type={show ? 'text' : 'password'}
							className={`form-control ${
								errors.password && touched.password ? 'input-error' : null
							}`}
							placeholder="Password"
							name="password"
							value={values.password}
							onChange={handleChange}
							onBlur={handleBlur}
						/>

						<button
							type="button"
							className="absolute right-[8px] top-[7px] text-2xl"
							onClick={() => setShow((show) => !show)}
						>
							{show ? <BiShow /> : <BiHide />}
						</button>
					</div>
					<div className="mt-2 flex items-center text-sm text-red-600" role="alert">
						{errors.password && touched.password && (
							<AlertIcon className="flex-shrink-1 me-1 inline h-4 w-4" />
						)}
						{errors.password && touched.password && (
							<div className="text-sm text-red-600" role="alert">
								<span className="font-medium">{errors.password}</span>
							</div>
						)}
					</div>
				</div>

				<Button type="submit" variant="primary" className="mt-4 w-full border" loading={loading}>
					Log in
				</Button>
			</form>

			<button
				className="mt-6 font-semibold text-slate-600 underline hover:text-slate-600"
				onClick={handlePasswordDisplay}
			>
				Forgot your password?
			</button>
		</div>
	)
}

export default Login
